import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
import Slider from 'react-slick';
 
import axios from 'axios';  
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {api_base_url, base_url} from '../common/Constants';

 
class PopularProducts extends React.Component{

    constructor(){
        super();

        
        this.state = {
            products : [],
            loading : 1,
            nav1: null,
        }
        

    }

    componentDidMount()
    {
          const script = document.createElement("script");
            script.src   = base_url+"assets/js/loadSlider.js";  
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
            if (window.loadProductSlider && this.state.loading == 1 ) {
             window.loadProductSlider();
            this.setState({loading:0})
            }
            };
    }
     
    render()
    { 
         var products = JSON.parse(localStorage.getItem("popularProducts"));
         var offerproducts = JSON.parse(localStorage.getItem("offerProducts"));
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
        {(products.length >0 || offerproducts.length > 0) && (
          <div class="ul-container">
            <section class="ul-products">
                <div class="ul-inner-container">
                    <div class="ul-section-heading">
                        <div class="left">
                            <span class="ul-section-sub-title">Popular collection</span>
                            <h2 class="ul-section-title">Shopping Every Day</h2>
                        </div>

                        <div class="right"> <Link  to={base_url+"shop"} class="ul-btn">More Collection <i class="flaticon-up-right-arrow"></i></Link></div>
                    </div>



                      

                        {products && (
                         
                         <div class="row ul-bs-row">
                        <div class="col-lg-3 col-md-4 col-12">
                            
                            <div class="ul-products-sub-banner">
                                <div class="ul-products-sub-banner-img">
                                    <img src={base_url +"assets/img/products-sub-banner-1.jpg"} alt="Popular Products" />
                                </div>
                                <div class="ul-products-sub-banner-txt">
                                    <h3 class="ul-products-sub-banner-title">Trending Now!</h3>
                                    <Link  to={base_url+"shop"} class="ul-btn">Shop Now <i class="flaticon-up-right-arrow"></i></Link>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-9 col-md-8 col-12">
                            
                            <div class="swiper ul-products-slider-1">
                                <div class="swiper-wrapper">

                                {products.map((item,key)=>( 
                                    
                                    <div class="swiper-slide">
                                        <div class="ul-product">
                                       

                                            <div class="ul-product-img">
                                                <img src={item.image} alt={item.title} />

                                               {/**** <div class="ul-product-actions">
                                                    <button><i class="flaticon-shopping-bag"></i></button>
                                                    <Link  to="#"><i class="flaticon-hide"></i></Link>
                                                    <button><i class="flaticon-heart"></i></button>
                                                </div> **/ }

                                                             <span class={item.discount > 0 ? "ul-product-discount-tag" : "ul-product-discount-tag dnone"}>{item.discount}% Off</span>   
                                               
                                            </div>

                                            <div class="ul-product-txt">
                                                <h4 class="ul-product-title"><Link  to={base_url+"products/"+item.slug} >{item.title}</Link></h4>
                                     
                                            </div>

                                                 <div class="ul-product-heading">
                                              <span class="ul-product-price">{item.price} {item.old_price != item.price && (<label>{item.old_price}</label>  )}</span>
                                            <Link  to={base_url+"products/"+item.slug}  class={item.quantity > 0 ? " add-button" : "dnone"}>Buy Now</Link>
                                                                                     <label class={item.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                                                                    </div>
                                        </div>
                                    </div>

                                ))}
                                 
                               
                                </div>
                            </div>

                             
                            <div class="ul-products-slider-nav ul-products-slider-1-nav">
                                <button class="prev"><i class="flaticon-left-arrow"></i></button>
                                <button class="next"><i class="flaticon-arrow-point-to-right"></i></button>
                            </div>
                        </div>
</div>
                            )}
                            { offerproducts.length > 0 && (
 <div class="row ul-bs-row">
                        <div class="col-lg-3 col-md-4 col-12">
                            
                            <div class="ul-products-sub-banner">
                                <div class="ul-products-sub-banner-img">
                                    <img src="assets/img/products-sub-banner-2.jpg" alt="Sub Banner" />
                                </div>
                                <div class="ul-products-sub-banner-txt">
                                    <h3 class="ul-products-sub-banner-title">Trending Now Only This Weekend!</h3>
                                    <Link  to={base_url+"shop"} class="ul-btn">Shop Now <i class="flaticon-up-right-arrow"></i></Link>
                                
                                
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-9 col-md-8 col-12">
                             
                            <div class="swiper ul-products-slider-2">
                                <div class="swiper-wrapper">
                                    
                                      {offerproducts.map((item,key)=>( 
                                    
                                    <div class="swiper-slide">
                                        <div class="ul-product">
                                       

                                            <div class="ul-product-img">
                                                <img src={item.image} alt={item.title} />

                                               {/**** <div class="ul-product-actions">
                                                    <button><i class="flaticon-shopping-bag"></i></button>
                                                    <Link  to="#"><i class="flaticon-hide"></i></Link>
                                                    <button><i class="flaticon-heart"></i></button>
                                                </div> **/ }

                                                   <span class={item.discount > 0 ? "ul-product-discount-tag" : "ul-product-discount-tag dnone"}>{item.discount}% Off</span>   
                                                
                                            </div>

                                            <div class="ul-product-txt">
                                                <h4 class="ul-product-title"><Link  to={base_url+"products/"+item.slug} >{item.title}</Link></h4>
                                     
                                            </div>

                                                 <div class="ul-product-heading">
                                              
                                                <Link  to={base_url+"products/"+item.slug}  class={item.quantity > 0 ? " add-button" : "dnone"}>Buy Now</Link>
                                                                                         <label class={item.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                                                                        </div>
                                        </div>
                                    </div>

                                ))}
                              




                                </div>
                            </div>

                            
                            <div class="ul-products-slider-nav ul-products-slider-2-nav">
                                <button class="prev"><i class="flaticon-left-arrow"></i></button>
                                <button class="next"><i class="flaticon-arrow-point-to-right"></i></button>
                            </div>
                        </div>
                        </div>
                            )}
                    
                </div>
            </section>
        </div>
        )}
        </div>
    );
}

}

export default PopularProducts;